import React, { useState } from "react";
import { Button, Container, ErrorMsg, Form, Input, Toast, PasswordPolicyHint, PasswordStrength } from "../../../../../Components";
import { FiInfo } from "react-icons/fi";
import { apis, patch } from "../../../../../Utils/axios";
import { useLoginHook } from "../../../../../Hooks/useLoginHook";
import { isPasswordStrong, PASSWORD_CHANGED_SUCCESS, PASSWORD_POLICY_HINT, PASSWORDS_DO_NOT_MATCH_ERROR } from "Utils/utils";

function ChangePassword() {
	const { logout } = useLoginHook();
	const [Values, setValues] = useState({
		old: "",
		password: "",
		confirm: "",
	});
	const [Loader, setLoader] = useState();
	const [Error, setError] = useState();

	const updatePassword = () => {
		if (Values.password !== Values.confirm) {
			return setError(PASSWORDS_DO_NOT_MATCH_ERROR);
		}
		setError();
		setLoader(true);
		if (!isPasswordStrong(Values.password)) {
			setError(PASSWORD_POLICY_HINT);
			setLoader();
			return;
		}
		patch(
			apis.changePassword,
			{
				email: Values.email,
				oldPassword: Values.old,
				password: Values.password,
			},
			(r, e) => {
				if (r) {
					Toast.success(PASSWORD_CHANGED_SUCCESS);
					setLoader();
					logout();
				} else if (e) {
					Toast.handleError(e);
					setLoader();
				}
			}
		);
	};

	return (
		<Container variant="outlined" className="h-full">
			<div className="flex items-start justify-between">
				<h4 className="mb-4">Change Password</h4>
				<div className="mb-4 text-xs text-right align-center text-secondary">
					<FiInfo className="mr-1" />
					Last changed on 02 Feb 2023
				</div>
			</div>
			<PasswordPolicyHint className="mb-4" />
			<Form onSubmit={updatePassword} loading={Loader}>
				<Input
					type="password"
					className="mb-4"
					value={Values.old}
					onChange={(old) => setValues((prev) => ({ ...prev, old }))}
					required
					label="Old Password"
					placeholder="Old Password"
					allowSpecialChars
				/>
				<div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-x-4">
					<div>
						<Input
							type="password"
							className="mb-1"
							value={Values.password}
							onChange={(password) => setValues((prev) => ({ ...prev, password }))}
							required
							label="New Password"
							placeholder="Password"
							allowSpecialChars
						/>
						<PasswordStrength password={Values.password} />
					</div>
					<Input
						type="password"
						value={Values.confirm}
						onChange={(confirm) => setValues((prev) => ({ ...prev, confirm }))}
						required
						label="Confirm New Password"
						placeholder="Confirm Password"
						className="mt-2 md:mt-0"
						allowSpecialChars
					/>
				</div>
				<ErrorMsg e={Error} />
				<Button loading={Loader} type="submit" className="w-full mt-2">
					Change Password
				</Button>
			</Form>
		</Container>
	);
}

export default ChangePassword;
